import { CircularProgress } from "@mui/material";
import { CenterContainer } from "components";
import { ENDPOINTS } from "config/constants";
import { useContextController } from "context";
import { login } from "context/actions";
import { useFetch } from "hooks";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserModel } from "types";

interface Data {
  user?: UserModel;
}

export default function Apple() {
  const { response, error, callFetch } = useFetch<Data>("POST");
  const [, dispatch] = useContextController();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    if (response && response.data && response.data.user) {
      login(response.data.user, dispatch);
      navigate("/");
    }
  }, [response, navigate, dispatch]);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error ? error?.message || JSON.stringify(error) : "Failed to login with apple", {
        variant: "error"
      });
      navigate("/");
    }
  }, [error, navigate, enqueueSnackbar]);

  useEffect(() => {
    const str = window.location.search.replace("?", "").replace("&", "").replace("code=", "");
    callFetch(ENDPOINTS.apple, { body: JSON.stringify({ code: str }) }).catch(console.error);
  }, [callFetch]);

  return (
    <CenterContainer>
      <CircularProgress />
    </CenterContainer>
  );
}
